import paymentApi from '../../utils/paymentApi';

function unwrap(response, fallback) {
  const payload = response?.data;
  if (!payload || Number(payload.code) !== 200) {
    const error = new Error(payload?.message || fallback);
    error.code = payload?.data?.error_code || payload?.code;
    throw error;
  }
  return payload.data;
}

export async function getBillingPackages(scope) {
  try {
    return unwrap(
      await paymentApi.get('/billing/packages', { params: { scope } }),
      '套餐信息暂时无法加载',
    );
  } catch (error) {
    if (error?.response?.data?.message) {
      const normalized = new Error(error.response.data.message);
      normalized.code = error.response.data?.data?.error_code || error.response.status;
      throw normalized;
    }
    throw error;
  }
}

export async function createBillingRefundRequest(data) {
  try {
    return unwrap(
      await paymentApi.post('/billing/refund-requests', data),
      '退款申请提交失败',
    );
  } catch (error) {
    if (error?.response?.data?.message) {
      const normalized = new Error(error.response.data.message);
      normalized.code = error.response.data?.data?.error_code || error.response.status;
      throw normalized;
    }
    throw error;
  }
}
